import { Avatar, Button, message, Popconfirm, notification, Rate, Space, Table, Modal, Tabs, Tooltip, Switch, Col, Input, Form, Row } from "antd";
import { useEffect } from "react";
import { SearchOutlined } from '@ant-design/icons';
import { UserOutlined } from "@ant-design/icons";
import { MdPhoneAndroid } from "react-icons/md";
import { MdEmail } from "react-icons/md";
import { FaAddressBook } from "react-icons/fa";
import { FaTransgender } from "react-icons/fa";
import { useState } from "react";
import { components, getRowClassName } from "../../utils/utils";
import { IoEye } from "react-icons/io5";
import { IoMdEyeOff } from "react-icons/io";
import IMAGES from "../../const/Image";
import { FaSliders } from "react-icons/fa6";
// import CategoryRequest from "../Categories/CategoryRequest";
import { useNavigate } from "react-router-dom";
import CommentRatingRequest from "./CommentRatingRequest";
import CommentFilter from "./CommentFilter";



const initialFilter = { page: 1 };

function CommentRating() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [labList, setLabList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterForm, setFilterForm] = useState({});
  const [filter, setFilter] = useState(initialFilter);
  const navigate = useNavigate();
  const [filteredComments, setFilteredComments] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { confirm } = Modal;

  const fetchRatingList = () => {
    const searchFilter = { ...filter, ...filterForm }
    setLoading(true);

    CommentRatingRequest.commentRatingList(filter)
      .then((response) => {
        const rawData = response?.data?.data?.data || [];
        console.log(rawData)
        const totalCount = response?.data?.total || 0;
        setLabList(rawData);
        setFilteredComments(rawData)
        setTotalRecords(totalCount);
      })
      .catch((error) => {
        message.error("Failed to fetch categories.");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    fetchRatingList();
  }, [filter]);

  const handleStatusChange = (checked, item) => {
    confirm({
      title: `Are you sure you want to ${checked ? "activate" : "deactivate"} this category?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        setLoading(true);
        CommentRatingRequest.statusUpdate({
          status: checked,
          id: item.id,
          categoryTitle: item.title,
        })
          .then((res) => {
            if (res && res.status === 200) {
              notification.success({
                message: "Status updated successfully",
              });
              setLabList((prevList) =>
                prevList.map((el) =>
                  el.id === item.id ? { ...el, is_active: checked ? "1" : "0" } : el
                )
              );
              fetchRatingList()
            } else {
              notification.error({
                message: "Failed to update status",
              });
            }
          })
          .catch(() => {
            notification.error({
              message: "Failed to update status",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      },
    });
  };


  const handleFilter = (value) => {
    setFilter({ ...filter, ...filterForm, ...initialFilter })
    console.log('filter', filter)
    setIsModalOpen(false)
  }
  const resetFilters = () => {
    form.resetFields();
    setFilterForm({});
    setFilter(initialFilter);
  };
  const handleChange = (pagination) => {
    setFilter({
      ...filter,
      page: pagination?.current,
    });
  };
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleDelete = (id) => {
    setLoading(true);
    CommentRatingRequest.deleteRating({ id })
      .then(() => {
        message.success("comment deleted successfully");
        setLabList((prevList) => prevList.filter((item) => item.id !== id));
        navigate(0, { state: { refresh: true } });
      })
      .catch((error) => {
        message.error("Failed to delete comment");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const columns = [
    {
      title: "S No.",
      dataIndex: "sno",
      key: "sno",
      width: "60px",
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
    },
    // {
    //   title: "Salon Image",
    //   dataIndex: "image",
    //   key: "image",
    //   // width: "200px",
    // },

    {
      title: "Ratings",
      dataIndex: "rating",
      key: "rating",
      // render:()=>(
      //   <Rate onChange={handleStartCount}/>
      // )
      render: (rating) => <Rate value={rating} disabled />,
    },
    {
      title: "Salon Name",
      dataIndex: "salonName",
      key: "salonName",
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={record.image || IMAGES.Customers}
            alt="Salon"
            style={{ width: "50px", height: "50px", marginRight: "8px" }}
          />
          <span>{record?.salon?.salonName}</span>
        </div>
      ),
    },
    {
      title: "Customer Name",
      dataIndex: "userName",
      key: "userName",
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center" }}>

          <span>{record?.user?.name}</span>
        </div>
      ),
    },
    {
      title: "Comments",
      dataIndex: "comments",
      key: "comments",
    },

    {
      title: "Status",
      dataIndex: "status",
      width: 120,
      align: "center",
      render: (is_active, item) => (
        <Switch
          checked={is_active === 1}
          checkedChildren="Approved"
          unCheckedChildren="Rejected"
          onChange={(checked) => handleStatusChange(checked, item)}
        />
      ),
    },

    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      // width:'200px',
      render: (_, record) => (
        <Space size="middle">


          <Popconfirm
            title="Delete this comment?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Tooltip title="Delete">
              <span className="action-icon-bg">
                <img src={IMAGES.DeleteIcon} alt="Delete" />
              </span>
            </Tooltip>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <div className="Create-Category">
        <Row gutter={[8, 8]} justify="space-between" align="middle" style={{ marginBottom: "2rem" }} >
          <Col>
            <h1 className="app-heading-med">Comment and Ratings</h1>
          </Col>

          <Col>

            <div style={{ display: "flex", gap: "1rem" }}>
              <Input
                placeholder="Search..."
                size="large"
                className="FilterSearchBox"
                onChange={(e) => setFilterForm({ ...filterForm, search: e.target.value })}
                value={filterForm?.search}
                style={{ width: "100%" }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleFilter();
                  }
                }}
              />
              <Button
                onClick={handleFilter}
                type="primary"
                htmlType="submit"
                className="addcity-btn"
                style={{ height: "39px" }}
              >
                <SearchOutlined />
              </Button>
              {/* <Button
                onClick={() => showModal()}
                type="primary"
                htmlType="submit"
                className="addcity-btn"
                style={{ height: "39px" }}
              >
                <FaSliders />
              </Button> */}
              <Button

                type="primary"
                className="addcity-btn"
                onClick={resetFilters}
                style={{ height: "39px" }}
              >
                Reset
              </Button>
             
            </div>
          </Col>
        </Row>
        <Table
          size="middle"
          bordered
          rowClassName={getRowClassName}
          components={components}
          columns={columns}
          loading={loading}
          onChange={handleChange}
          dataSource={filteredComments}
          pagination={{
            total: totalRecords,
            current: filter?.page || 0,
            defaultCurrent: 1
          }}
        />
      </div>
      <CommentFilter handleFilter={handleFilter} form={form} filterForm={filterForm} setFilterForm={setFilterForm} isModalOpen={isModalOpen} handleCancel={handleCancel} />
    </>
  );
}

export default CommentRating;